import { Howl } from "howler";
export class Sound {
    constructor(parameter) {
        this.howl = new Howl(parameter);
    }
    play(value) {
        this.id = this.howl.play(value);
        return this;
    }
    pause(id) {
        this.howl.pause(id);
        return this;
    }
    resume() {
        this.howl.play(this.id);
    }
    stop(id) {
        this.howl.stop(id);
        return this;
    }
    mute(muted = true, id) {
        this.howl.mute(muted, id);
        return this;
    }
    fade(from, to, durationMs, id) {
        this.howl.fade(from, to, durationMs, id);
    }
    rate(rate, id) {
        this.howl.rate(rate, id);
    }
    seek(seek, id) {
        return this.howl.seek(seek, id);
    }
    loop(loop, id) {
        this.howl.loop(loop, id);
    }
    state() {
        return this.howl.state();
    }
    playing(id) {
        return this.howl.playing(id);
    }
    duration(id) {
        return this.howl.duration(id);
    }
    on(event, callback, id) {
        this.howl.on(event, callback, id);
        return this;
    }
    once(event, callback, id) {
        this.howl.once(event, callback, id);
        return this;
    }
    off(event, callback, id) {
        this.howl.off(event, callback, id);
        return this;
    }
    load() {
        this.howl.load();
    }
    unload() {
        this.howl.unload();
    }
    pos(x, y, z, id) {
        return this.howl.pos(x, y, z, id);
    }
    pos3d(x, y, z, id) {
        return this.howl.pos(x, y, z, id);
    }
    volume(volume, id) {
        if (id) {
            this.howl.volume(volume, id);
        }
        else {
            this.howl.volume(volume);
        }
        return this.howl.volume();
    }
}
//# sourceMappingURL=Sound.js.map